import { FlightItem } from "@/typings";

import usePlatform from "../usePlatform";
import CabinInfoMobile from "./CabinInfoMobile";
import CabinInfoPc from "./CabinInfoPc";

interface CabinInfoProps {
  data: FlightItem;
  partialDisplay: boolean;
}

const CabinInfo = (props: CabinInfoProps) => {
  const { isPc } = usePlatform();

  return isPc ? <CabinInfoPc {...props} partialDisplay={props.partialDisplay} /> : <CabinInfoMobile {...props} />;
};

export default CabinInfo;
